import React, { useRef, useState } from "react";

const AcademyReplyVideo = ({ reply, onComplete }) => {
  const [failedUrl, setFailedUrl] = useState(null);
  const [completion, setCompletion] = useState(null);
  const completionRef = useRef(null);
  let videoUrl = null;
  if (reply?.uiAction === "SHOW_VIDEO" && typeof reply.videoUrl === "string") {
    try {
      const candidate = reply.videoUrl.trim();
      const url = new URL(candidate);
      if (["https:", "http:"].includes(url.protocol)) videoUrl = candidate;
    } catch {
      // An invalid or missing video URL must not break the chat message.
    }
  }
  if (!videoUrl) return null;

  const label = Number.isInteger(reply.videoNumber)
    ? `Spire Academy video ${reply.videoNumber}` : "Spire Academy video";
  const videoNumber = Number.isInteger(reply.videoNumber) && reply.videoNumber > 0 ? reply.videoNumber : null;
  const completionKey = `${videoUrl}|${videoNumber}`;
  const completionStatus = completion?.key === completionKey ? completion.status : null;

  const reportCompletion = async () => {
    if (!videoNumber || !onComplete) return;
    if (completionRef.current?.key === completionKey &&
      ["pending", "done"].includes(completionRef.current.status)) return;
    const updateCompletion = (status) => {
      const next = { key: completionKey, status };
      completionRef.current = next;
      setCompletion(next);
    };
    updateCompletion("pending");
    try {
      updateCompletion(await onComplete() === false ? "error" : "done");
    } catch {
      updateCompletion("error");
    }
  };

  return (
    <div className="mt-2 mb-2" style={{ width: "100%", maxWidth: "480px" }}>
      {failedUrl === videoUrl ? (
        <p role="status" className="mb-1">Unable to play this video here. Use the link below to open it.</p>
      ) : (
        <video
          key={videoUrl}
          src={videoUrl}
          aria-label={label}
          controls
          playsInline
          preload="metadata"
          onError={() => setFailedUrl(videoUrl)}
          onEnded={reportCompletion}
          style={{ display: "block", width: "100%", borderRadius: "8px", background: "#000" }}
        >
          Your browser does not support embedded video.
        </video>
      )}
      <a href={videoUrl} target="_blank" rel="noopener noreferrer" className="d-inline-block mt-1">
        Open video in a new tab
      </a>
      {completionStatus === "pending" && <p role="status" className="small mb-0">Saving completion…</p>}
      {completionStatus === "done" && <p role="status" className="small mb-0">Video completed.</p>}
      {completionStatus === "error" && (
        <div className="small mt-1">
          <span>Unable to save video completion. </span>
          <button type="button" className="btn btn-link btn-sm p-0" onClick={reportCompletion}>
            Retry
          </button>
        </div>
      )}
    </div>
  );
};

export default AcademyReplyVideo;
